import { gql } from '@apollo/client';

export const VALIDATE_MEASURE_FORMULA = gql`
  query ValidateMeasureFormula($input: MeasureFormulaInput!) {
    measureFormulaValidate(input: $input) {
      validationError
    }
  }
`;
